export default __webpack_public_path__ + "static/webright-e47c0786af682421ccf7d4e888910508.svg";